import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';

import { setNewQuestion, updateTabStates } from '../../../store/actions';

export default function LeftMenuDesign() {

    const themeMode = useSelector(state => state.themeMode);
    const questions = useSelector(state => state.questions);

    const topMenuTabs = useSelector((state) => state.topMenuTabs);
    const currentSurvey = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.currentSurvey;
    
    // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
    // const questions = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.questions;

    const dispatch = useDispatch();

    const [tabs, setTabs] = useState([
        { name: "Input Panel", href: "#", current: true },
        { name: "QBank", href: "#", current: false },
    ]);

    const searchInputPanelAndQBank = (e) => {
        const filteredList = inputPanel.filter((item) =>
            item["name"].toLowerCase().includes(e.target.value.toLowerCase())
        );
        setFilteredInputPanel(filteredList);

        // QBank filtering & if there is match, open the accordion
        const filteredQBankList = qBank.map((bank) => {
            const filteredQuestions = bank.questions.filter((question) =>
                question.question.toLowerCase().includes(e.target.value.toLowerCase())
            );
            if (filteredQuestions.length > 0) {
                bank.open = true;
            } else {
                bank.open = false;
            }
            if (e.target.value === "") {
                bank.open = false;
            }
            return { ...bank, questions: filteredQuestions };
        });

        setFilteredQBank(filteredQBankList);
    };

    const [inputPanel, setInputPanel] = useState([
        {
            value: 1,
            name: "Multiple Choice",
            img: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-5"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                </svg>
            ),
        },
        {
            value: 2,
            name: "Star Rating",
            img: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-5"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
                    />
                </svg>
            ),
        },
        {
            value: 3,
            name: "Checkbox",
            img: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-5"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m4.5 12.75 6 6 9-13.5"
                    />
                </svg>
            ),
        },
        {
            value: 4,
            name: "Dropdown",
            img: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-5"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m4.5 15.75 7.5-7.5 7.5 7.5"
                    />
                </svg>
            ),
        },
        {
            value: 5,
            name: "Multi-Select Dropdown",
            img: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-5"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
                    />
                </svg>
            ),
        },
        {
            value: 6,
            name: "Yes-No",
            img: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-5"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                </svg>
            ),
        },
        // {
        //     value: 7,
        //     name: "File Upload",
        //     img: (
        //         <svg
        //             xmlns="http://www.w3.org/2000/svg"
        //             fill="none"
        //             viewBox="0 0 24 24"
        //             strokeWidth="1.5"
        //             stroke="currentColor"
        //             className="size-5"
        //         >
        //             <path
        //                 strokeLinecap="round"
        //                 strokeLinejoin="round"
        //                 d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"
        //             />
        //         </svg>
        //     ),
        // },
        // {
        //     value: 8,
        //     name: "Image Picker",
        //     img: (
        //         <svg
        //             xmlns="http://www.w3.org/2000/svg"
        //             fill="none"
        //             viewBox="0 0 24 24"
        //             strokeWidth="1.5"
        //             stroke="currentColor"
        //             className="size-5"
        //         >
        //             <path
        //                 strokeLinecap="round"
        //                 strokeLinejoin="round"
        //                 d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
        //             />
        //         </svg>
        //     ),
        // },
        {
            value: 9,
            name: "Ranking",
            img: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-5"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941"
                    />
                </svg>
            ),
        },
        {
            value: 10,
            name: "Single Line",
            img: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-5"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                    />
                </svg>
            ),
        },
        {
            value: 11,
            name: "Long Text",
            img: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-5"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                    />
                </svg>
            ),
        },
        // {
        //     value: 12,
        //     name: "Multiple Textboxes",
        //     img: (
        //         <svg
        //             xmlns="http://www.w3.org/2000/svg"
        //             fill="none"
        //             viewBox="0 0 24 24"
        //             strokeWidth="1.5"
        //             stroke="currentColor"
        //             className="size-5"
        //         >
        //             <path
        //                 strokeLinecap="round"
        //                 strokeLinejoin="round"
        //                 d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"
        //             />
        //         </svg>
        //     ),
        // },
            {
            value: 12,
            name: "Nested Question",
            img: (
               <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-5">
  <path strokeLinecap="round" strokeLinejoin="round" d="M8.242 5.992h12m-12 6.003H20.24m-12 5.999h12M4.117 7.495v-3.75H2.99m1.125 3.75H2.99m1.125 0H5.24m-1.92 2.577a1.125 1.125 0 1 1 1.591 1.59l-1.83 1.83h2.16M2.99 15.745h1.125a1.125 1.125 0 0 1 0 2.25H3.74m0-.002h.375a1.125 1.125 0 0 1 0 2.25H2.99" />
</svg>

            ),
        },
    ]);

    const [filteredInputPanel, setFilteredInputPanel] = useState(inputPanel);

    const [qBank, setQBank] = useState(
        [
        // {
        //     value: 2,
        //     name: "Data Management",
        //     open: false,
        //     questions: [
        //         "Question 1",
        //         "Question 2",
        //         "Question 3",
        //         "Question 4",
        //         "Question 5",
        //     ],
        // },
        // {
        //     value: 3,
        //     name: "GenAI",
        //     open: false,
        //     questions: ["Question 6", "Question 7", "Question 8", "Question 9"],
        // },
        // {
        //     value: 4,
        //     name: "Data Quality",
        //     open: false,
        //     questions: ["Question 10", "Question 11", "Question 12"],
        // },
        // {
        //     value: 5,
        //     name: "Own Questions",
        //     open: false,
        //     questions: [
        //         "Question 13",
        //         "Question 14",
        //         "Question 15",
        //         "Question 16",
        //         "Question 17",
        //         "Question 18",
        //         "Question 19",
        //         "Question 20",
        //     ],
        // },
    ]);

    useEffect(() => {
        let newQBank = [];
        let count=0;
        questions.map((question) => {
            if (question.created_from === 'organization' && count<100) {
                if (newQBank.find((bank) => bank.name === "My Questions") === undefined) {
                    newQBank.push({
                        name: "My Questions",
                        open: false,
                        questions: [question],
                    });
                } else {
                    newQBank.find((bank) => bank.name === "My Questions").questions.push(question);
                }
                count ++;
            } else if (question.created_from === 'benchmarked') {
                if (newQBank.find((bank) => bank.name === question.benchmarked_survey) === undefined) {
                    newQBank.push({
                        name: question.benchmarked_survey,
                        open: false,
                        questions: [question],
                    });
                } else {
                    newQBank.find((bank) => bank.name === question.benchmarked_survey).questions.push(question);
                }
            }
        });
        setQBank(newQBank);
        setFilteredQBank(newQBank);
    }, [questions]);

    const [filteredQBank, setFilteredQBank] = useState([]);

    const handleTabChange = (newValue) => {
        tabs.map((tab) => (tab.current = false));
        tabs.find((tab) => tab.name === newValue).current = true;
        setTabs([...tabs]);
    };

    const handleOpenQuestions = (value) => {
        let bank = filteredQBank.find((q) => q.name === value);
        bank.open = !bank.open;
        setFilteredQBank([...filteredQBank]);
    };

    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }

    const handleAddQuestion = (panel) => {
        if (panel.name === "Multiple Choice") {
            // dispatch(setNewQuestion({type: "radiogroup", from: "inputpanel"}));
            dispatch(updateTabStates(topMenuTabs.activeTab, "newQuestion", {type: "radiogroup", from: "inputpanel"}));
        } else if (panel.name === "Star Rating") {
            // dispatch(setNewQuestion({type: "rating", from: "inputpanel"}));
            dispatch(updateTabStates(topMenuTabs.activeTab, "newQuestion", {type: "rating", from: "inputpanel"}));
        } else if (panel.name === "Checkbox") {
            // dispatch(setNewQuestion({type: "checkbox", from: "inputpanel"}));
            dispatch(updateTabStates(topMenuTabs.activeTab, "newQuestion", {type: "checkbox", from: "inputpanel"}));
        } else if (panel.name === "Dropdown") {
            // dispatch(setNewQuestion({type: "dropdown", from: "inputpanel"}));
            dispatch(updateTabStates(topMenuTabs.activeTab, "newQuestion", {type: "dropdown", from: "inputpanel"}));
        } else if (panel.name === "Multi-Select Dropdown") {
            // dispatch(setNewQuestion({type: "tagbox", from: "inputpanel"}));
            dispatch(updateTabStates(topMenuTabs.activeTab, "newQuestion", {type: "tagbox", from: "inputpanel"}));
        } else if (panel.name === "Yes-No") {
            // dispatch(setNewQuestion({type: "boolean", from: "inputpanel"}));
            dispatch(updateTabStates(topMenuTabs.activeTab, "newQuestion", {type: "boolean", from: "inputpanel"}));
        } else if (panel.name === "Ranking") {
            // dispatch(setNewQuestion({type: "ranking", from: "inputpanel"}));
            dispatch(updateTabStates(topMenuTabs.activeTab, "newQuestion", {type: "ranking", from: "inputpanel"}));
        } else if (panel.name === "Single Line") {
            // dispatch(setNewQuestion({type: "text", from: "inputpanel"}));
            dispatch(updateTabStates(topMenuTabs.activeTab, "newQuestion", {type: "text", from: "inputpanel"}));
        } else if (panel.name === "Long Text") {
            // dispatch(setNewQuestion({type: "comment", from: "inputpanel"}));
            dispatch(updateTabStates(topMenuTabs.activeTab, "newQuestion", {type: "comment", from: "inputpanel"}));
        }else if (panel.name === "Nested Question") {
            // dispatch(setNewQuestion({type: "comment", from: "inputpanel"}));
            dispatch(updateTabStates(topMenuTabs.activeTab, "newQuestion", {type: "paneldynamic", from: "inputpanel"}));
        }
    };

    const handleAddQuestionFromQBank = (question) => {
        const _question = JSON.parse(JSON.stringify(question));
        _question["from"] = "qbank"
        _question["options"] = question.options.map((option, index) => {
            return {
                value: index + 1,
                text: option
            };
        });
        // dispatch(setNewQuestion(_question));
        dispatch(updateTabStates(topMenuTabs.activeTab, "newQuestion", _question));
    }

    return (
        <div className={`${currentSurvey.status !== "Draft" ? "cursor:auto pointer-events-none opacity-50" : ""}`}>
            <div className={`flex cursor-default items-center justify-between rounded-lg pt-[0.75rem] pr-[0.75rem] pb-[1.5rem] pl-[1.25rem] 
                    text-[1.25rem] font-bold space-x-2`}>
                <span
                    className={` whitespace-nowrap break-words text-ellipsis  min-w-0 w-full cursor-default ${themeMode === "dark" ? "text-white" : "text-[#0F121A]"
                        }`}
                >
                    Design
                </span>
            </div>

            <div
                className={`flex items-center h-[2rem] border rounded-lg pl-2 pr-3 mx-[0.75rem] py-2 focus-within:ring-1 focus-within:ring-blue-500
                                            ${themeMode === "dark"
                        ? "border-[#ffffff17] bg-[#ffffff05]"
                        : "border-[#00000017] bg-[#00000005]"
                    }
                                            `}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1"
                    stroke={themeMode === "dark" ? "#ffffffcc" : "black"}
                    className="size-[18px] hover:stroke-white"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                    />
                </svg>
                <input
                    type="text"
                    placeholder="Search"
                    className={`w-full focus:outline-none bg-transparent ${themeMode==="dark"?"text-white":"text-black"} px-2`}
                    onChange={searchInputPanelAndQBank} // Her değişiklikte tetiklenir
                />
            </div>

            <div
                className={`h-px mt-4 mb-0 ${themeMode === "dark" ? "bg-[#ffffff17]" : "bg-[#0000001a]"
                    }`}
            ></div>

            <div className="sm:block">
                <div
                    className={`border-b ${themeMode === "dark"
                        ? "border-[#ffffff17]"
                        : "border-[#0000001a]"
                        }`}
                >
                    <nav
                        aria-label="Tabs"
                        className="-mb-px flex space-x-2" 
                        id="designLeftMenuTabs"
                    >
                        {tabs.map((tab) => (
                            <a
                                key={tab.name}
                                id={`${tab.name==="Input Panel"?"designLeftMenuInputPanel":"designLeftMenuQbank"}`}
                                href={tab.href}
                                onClick={() => handleTabChange(tab.name)}
                                aria-current={tab.current ? "page" : undefined}
                                className={classNames(
                                    tab.current
                                        ? "border-[#4d7ff5] text-[#4d7ff5]"
                                        : themeMode === "dark"
                                            ? "border-transparent rounded text-[#e5e7eb] hover:border-gray-300 hover:bg-[#a5bdff1a]"
                                            : "border-transparent rounded text-[#0f121a] hover:border-[#a5bdff1a] hover:bg-[#a5bdff1a]",
                                    "whitespace-nowrap border-b-2 px-2 py-2 text-sm font-medium"
                                )}
                            >
                                {tab.name}
                            </a>
                        ))}
                    </nav>
                </div>
            </div>
            <div className='max-h-[calc(100vh-230px)] overflow-y-auto overflow-x-hidden'>
            {tabs.find((tab) => tab.current).name === "Input Panel" && (
                <ul className="px-3 pt-4 space-y-0 flex flex-col">
                    {filteredInputPanel.map((panel, index) => (
                        <li
                            key={panel.name}
                            className=" flex flex-col min-h-[2rem] my-0 py-0 group"
                            onClick={() => handleAddQuestion(panel)}
                        >
                            <div
                                className={`flex cursor-pointer items-center justify-between min-h-[2rem] rounded-lg px-2 py-1 hover:bg-[#A5BDFF1A] ${themeMode === "dark"
                                    ? "text-white  "
                                    : "text-gray-500  "
                                    } `}
                            >
                                <div className="flex items-center">
                                    <span className="mr-2">{panel.img}</span>
                                    <span
                                        className={` whitespace-nowrap break-words text-ellipsis overflow-hidden min-w-0 ${themeMode === "dark"
                                            ? "text-white"
                                            : "text-[#0F121A]"
                                            }`}
                                    >
                                        {panel.name}
                                    </span>
                                </div>
                                <div
                                    className="hidden group-hover:block hover:bg-[#a5bdff0d] hover:rounded-[3px] hover:p-[2px]"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-4"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 4.5v15m7.5-7.5h-15"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
            {tabs.find((tab) => tab.current).name === "QBank" && (
                <ul className="px-3 pt-4 space-y-0 flex flex-col">
                    {filteredQBank.map((bank, index) => (
                        <li
                            key={bank.name}
                            className=" flex flex-col min-h-[2rem] my-0 py-0"
                            onClick={() => handleOpenQuestions(bank.name)}
                        >
                            <div
                                className={`flex cursor-pointer items-center justify-between min-h-[2rem] rounded-lg px-2 py-1 hover:bg-[#A5BDFF1A] ${themeMode === "dark"
                                    ? bank.open
                                        ? "text-white"
                                        : "text-[#8E99AF] hover:text-white"
                                    : "text-gray-500  "
                                    } `}
                            >
                                <div className="flex items-center">
                                    <span className="mr-2">
                                        <svg
                                            className="size-4"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            xmlns="http://www.w3.org/2000/svg"
                                            transform={!bank.open ? "rotate(270)" : ""}
                                        >
                                            <path d="M7.8,10.8L11.7,7H4L7.8,10.8z"></path>
                                        </svg>
                                    </span>
                                    <span
                                        className={` whitespace-nowrap break-words text-ellipsis overflow-hidden min-w-0`}
                                    >
                                        {bank.name}
                                    </span>
                                </div>
                            </div>
                            {bank.open && (
                                <ul className="pl-3 space-y-0 flex flex-col">
                                    {bank.questions.map((question, index) => (
                                        <li
                                            key={`${question.question}-${index}`}
                                            className=" flex flex-col min-h-[2rem] my-0 py-0 group"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleAddQuestionFromQBank(question);
                                            }}
                                        >
                                            <div
                                                className={`flex cursor-pointer items-center justify-between min-h-[2rem] rounded-lg px-2 py-1 hover:bg-[#A5BDFF1A] ${themeMode === "dark"
                                                    ? "text-white"
                                                    : "text-gray-500"
                                                    }`}
                                            >
                                                <div className="flex items-center">
                                                    <span className="whitespace-normal break-words text-ellipsis overflow-hidden min-w-0">
                                                        {question.question}
                                                    </span>
                                                </div>
                                                <div className="hidden group-hover:block hover:bg-[#a5bdff0d] hover:rounded-[3px] hover:p-[2px]">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth="1.5"
                                                        stroke="currentColor"
                                                        className="size-4"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M12 4.5v15m7.5-7.5h-15"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            )}
            </div>

            <div
                className={`h-px mt-4 ${themeMode === "dark" ? "bg-[#ffffff17]" : "bg-[#0000001a]"
                    }`}
            ></div>
        </div>
    )
}
